import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Grid,
  Box,
  CircularProgress,
  Icon,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import withTheme from "@material-ui/core/styles/withTheme";
import styled from "styled-components";
import { AddCircleOutline } from "@material-ui/icons";
import HeaderInfo from "../../waybee-ui/HeaderInfo/HeaderInfo";
import Group from "../../waybee-ui/Group";
import BackButton from "../../components/BackButton";
import TableGrid from "../../waybee-ui/TableGrid";
import OccurrenceDialog from "./components/OccurrenceDialog";
import StudentService from "../../services/StudentService";
import BlockButton from "../../waybee-ui/BlockButton/BlockButton";
import NewOccurrenceDialog from "./components/NewOccurrenceDialog";
import TeacherService from "../../services/TeacherService";

const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
`;
const FilterContainer = styled(FormControl)`
  margin: 8px;
  min-width: 224px;
`;

const LoadContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 32px 8px;
`;

const OccurrenceList = styled(Group)`
  padding: 0 30px 12px 30px;
`;

const FallBackMessage = styled(Typography)`
  padding-top: 12px;
  margin: 0;
`;

class StudentOccurrences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      student: null,
      selectedOccurrence: null,
      filterOptions: [],
      occurrenceTypes: undefined,
      occurrenceTypeSelected: undefined,
      filterSelected: {
        occurrenceType: undefined,
        occurrenceReason: undefined,
        occurrenceYear: undefined
      },
      loadingOccurrences: false,
      newOccurrence: false
    };
  }

  async componentDidMount() {
    const currentYear = new Date().getFullYear();
    const filterOptions = await this.getFilterOptions(currentYear);
    await this.setState(prevState => ({
      filterOptions,
      filterSelected: {
        ...prevState.filterSelected,
        occurrenceYear: currentYear
      }
    }));
    this.getOccurrenceType();
    this.getStudent();
    this.getOccurrences();
  }

  async handleYearChange(value) {
    await this.setState(prevState => ({
      filterSelected: {
        ...prevState.filterSelected,
        occurrenceYear: value
      }
    }));
    this.getOccurrences();
  }

  handleDialogClose(hasChanged) {
    this.setState({
      dialogOpen: false,
      selectedOccurrence: null,
      newOccurrence: false
    });
    if (typeof hasChanged === "boolean") {
      this.getOccurrences();
    }
  }

  handleSelectOccurrence = async occurrence => {
    const classId = localStorage.getItem("class");
    let occurrenceData = occurrence;
    const { filterSelected } = this.state;

    const occurrenceStage = await TeacherService.getOccurrenceStages(
      classId,
      filterSelected.occurrenceYear
    );
    const filteredStage = occurrenceStage.filter(
      stage => stage.id === occurrence.idStage
    )[0];

    if (filteredStage) {
      occurrenceData = { ...occurrence, stage: filteredStage.name };
    } else {
      occurrenceData = { ...occurrence, stage: occurrence.idStage };
    }

    this.setState({ dialogOpen: true, selectedOccurrence: occurrenceData });
  };

  handleOccurrenceTypeChange = async type => {
    if (type.reasons) {
      type.reasons.unshift({
        name: "Todos",
        id: "0-0"
      });
    }

    await this.setState(prevState => ({
      occurrenceTypeSelected: type,
      filterSelected: {
        ...prevState.filterSelected,
        occurrenceType: type.idGroup && Number(type.idGroup)
      }
    }));
    await this.getOccurrences();
  };

  async handleOccurrenceReasonChange(reason) {
    if (reason) {
      await this.setState(prevState => ({
        filterSelected: {
          ...prevState.filterSelected,
          occurrenceReason: Number(reason.split("-")[0])
        }
      }));
    }
    this.getOccurrences();
  }

  getOccurrenceType = async () => {
    const classId = localStorage.getItem("class");
    const occurrenceTypes = await TeacherService.getOccurrenceTypes(classId);

    const filterAllTypes = {
      id: "0",
      idGroup: undefined,
      reasons: undefined,
      name: "Todos"
    };

    const updatedOccurrenceTypes = [filterAllTypes, ...occurrenceTypes];
    this.setState({ occurrenceTypes: updatedOccurrenceTypes });
  };

  getStudent = async () => {
    const {
      match: {
        params: { studentId }
      }
    } = this.props;
    const student = await StudentService.getStudentById(studentId);
    this.setState({ student });
  };

  getOccurrences = async (callback = () => {}) => {
    const {
      match: {
        params: { studentId }
      }
    } = this.props;
    const { filterSelected } = this.state;

    this.setState({ loadingOccurrences: true });
    const occurrences = await StudentService.getOccurrences(
      studentId,
      filterSelected.occurrenceYear,
      filterSelected.occurrenceType,
      filterSelected.occurrenceReason
    );
    this.setState({ occurrences, loadingOccurrences: false }, callback);
  };

  redirectTo = () => {
    const { match } = this.props;
    const { student } = this.state;
    const classId = localStorage.getItem("class");
    if (match.params.id) {
      return `/classes/${match.params.id}/individualOccurrences`;
    }
    return classId ? `/student/${student.id}` : "/classes";
  };

  getFilterOptions = async year => {
    const years = [];
    for (let i = 0; i <= 5; i += 1) {
      years.push(year - i);
    }
    return years;
  };

  openNewOccurrence() {
    this.setState({ newOccurrence: true, dialogOpen: true });
  }

  render() {
    const {
      dialogOpen,
      selectedOccurrence,
      student,
      occurrences,
      filterOptions,
      occurrenceTypes,
      occurrenceTypeSelected,
      filterSelected,
      loadingOccurrences,
      newOccurrence
    } = this.state;
    const { theme } = this.props;

    if (!student || !occurrences) {
      return (
        <Box p={6} textAlign="center">
          <CircularProgress />
        </Box>
      );
    }

    const fallBack = loadingOccurrences ? (
      <LoadContainer>
        <CircularProgress />
      </LoadContainer>
    ) : (
      <FallBackMessage>
        Nenhuma ocorrência cadastrada para o ano.
      </FallBackMessage>
    );

    return (
      <Grid container spacing={2}>
        <BackButton to={this.redirectTo} />
        <Grid item xs={12}>
          <Group>
            <HeaderInfo
              name={student.name}
              info={`R.A: ${student.ra}`}
              photo={student.photo}
            />
            <FiltersContainer>
              <FilterContainer sx={{ minWidth: 120 }}>
                <InputLabel>Ano</InputLabel>
                <Select
                  labelId="select-label"
                  id="year-filter"
                  label="Ano"
                  value={filterSelected.occurrenceYear}
                  onChange={e => this.handleYearChange(e.target.value)}
                >
                  {filterOptions.map(year => (
                    <MenuItem value={year}>{year}</MenuItem>
                  ))}
                </Select>
              </FilterContainer>
              {occurrenceTypes && (
                <FilterContainer sx={{ minWidth: 300 }}>
                  <InputLabel id="occurrenceType-label">
                    Grupos de ocorrência
                  </InputLabel>
                  <Select
                    id="occurrenceType-label"
                    name="occurrenceType"
                    defaultValue={occurrenceTypes[0]}
                    onChange={e =>
                      this.handleOccurrenceTypeChange(e.target.value)}
                  >
                    {occurrenceTypes.map(occurrenceType => (
                      <MenuItem key={occurrenceType.id} value={occurrenceType}>
                        {occurrenceType.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FilterContainer>
              )}
              {filterSelected.occurrenceType && occurrenceTypeSelected.reasons && (
                <FilterContainer>
                  <InputLabel id="reason-label">Tipos da ocorrência</InputLabel>
                  <Select
                    name="reason"
                    id="reason-label"
                    defaultValue={occurrenceTypeSelected.reasons[0]}
                    onChange={e =>
                      this.handleOccurrenceReasonChange(e.target.value)}
                  >
                    {occurrenceTypeSelected.reasons.map(reason => (
                      <MenuItem key={reason.id} value={reason.id}>
                        {reason.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FilterContainer>
              )}
            </FiltersContainer>
          </Group>
        </Grid>
        <Grid item xs={12}>
          <BlockButton
            startIcon={<AddCircleOutline />}
            onClick={() => {
              this.openNewOccurrence();
            }}
          >
            ADICIONAR OCORRÊNCIA
          </BlockButton>
        </Grid>
        <Grid item xs={12}>
          <OccurrenceList>
            {occurrences.length > 0 && !loadingOccurrences ? (
              <TableGrid>
                {occurrences.map(occur => {
                  const stringDate = new Date(occur.date)
                    .toLocaleString("pt-BR")
                    .split(",");
                  return (
                    <TableGrid.Row
                      actionIcon
                      button
                      onClick={() => this.handleSelectOccurrence(occur)}
                    >
                      <TableGrid.Cell xs={1}>
                        <Icon
                          style={{
                            color: theme.palette.primary.main,
                            fontSize: 32
                          }}
                        >
                          {occur.icon}
                        </Icon>
                      </TableGrid.Cell>
                      <TableGrid.Title xs={7}>{occur.reason}</TableGrid.Title>
                      <TableGrid.Text xs={4}>
                        {`${stringDate[0]} ás ${stringDate[1]}`}
                      </TableGrid.Text>
                    </TableGrid.Row>
                  );
                })}
              </TableGrid>
            ) : (
              fallBack
            )}
          </OccurrenceList>
        </Grid>
        {selectedOccurrence && (
          <OccurrenceDialog
            open={dialogOpen}
            studentId={student.id}
            handleClose={e => this.handleDialogClose(e)}
            occurrence={selectedOccurrence}
          />
        )}
        {newOccurrence && (
          <NewOccurrenceDialog
            open={dialogOpen}
            studentId={student.id}
            studentName={student.name}
            handleClose={e => this.handleDialogClose(e)}
          />
        )}
      </Grid>
    );
  }
}

StudentOccurrences.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.arrayOf({})
  }).isRequired,
  theme: PropTypes.objectOf({}).isRequired
};
export default withRouter(withTheme(StudentOccurrences));
